import {
  faExclamationTriangle,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { Button } from 'semantic-ui-react'
import * as Config from '../../../public/external-links'
import Accordion from '../../common/Accordion'
import GreyBox from '../../common/GreyBox'
import PageTitle from '../../PageTitle'
import Conditional from '../../common/Conditional'
import { ICallout } from '../../../models/Callout'
import useCallout from '../../../hooks/useCallout'
import CalloutDisplay from '../../common/CalloutDisplay'
import LoaderContext from '../../context/FormLoader'
import DocumentLink from '../../common/DocumentLink'

export const AnnualLeaveAgreementHeader = (props) => {
  const mountedRef = useRef(false)
  const [data, setData] = useState<ICallout[]>([])
  const [getCallout] = useCallout('AnnualLeaveAgreementTemplate', 'Before')
  const [isLoading, setIsLoading] = useState(true)
  const loader = useContext(LoaderContext)

  useEffect(() => {
    mountedRef.current = true
    loader.up()
    if (mountedRef.current) {
      getCallout()
        .then((response) => {
          if (mountedRef.current) {
            setData(response.callouts)
          }
        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setIsLoading(false)
          loader.down()
        })
    }
    return () => {
      mountedRef.current = false
    }
  }, [])
  return (
    <>
      <PageTitle title="Agreement to annual leave in advance - Templates - Fair Work Ombudsman" />
      <h1>Agreement to take annual leave in advance</h1>
      <Accordion
        heading="Welcome to our Template Tool"
        expanded={props.show}
        onClick={() => props.setShow()}
      >
        <p></p>
        <Conditional if={!isLoading}>
          {data &&
            data.map((c, i) => (
              <CalloutDisplay
                key={i}
                className=""
                content={c.content}
                name="AnnualLeaveAgreement"
              />
            ))}
        </Conditional>
        <p></p>
        <p>
          This tool will help you prepare an agreement to take annual leave in
          advance.
        </p>
        <p>
          The tool will ask you simple questions and use your answers to tailor
          an agreement for you. You will be able to save and edit your agreement
          at the end.
        </p>
        <h2>Important information</h2>
        <p>
          Click the&nbsp;
          <FontAwesomeIcon
            className="ml-xs"
            icon={faExclamationTriangle}
            size={'1x'}
            color={'#da291c'}
          />
          &nbsp;buttons for important information about workplace rights and
          obligations
        </p>
        <h2>Get help</h2>
        <p>
          Click the&nbsp;
          <FontAwesomeIcon
            className="ml-xs"
            icon={faInfoCircle}
            size={'lg'}
            color={'#1b365d'}
          />
          &nbsp;buttons for explanations or help answering the question
        </p>
        <p>
          To protect your privacy none of the information you enter is stored in
          this tool or captured by the Office of the Fair Work Ombudsman.
        </p>

        <GreyBox>
          <p>
            <strong>Before you begin:</strong> To prepare your letter
            you&apos;ll need to know if an award or enterprise agreement applies
            to the employee, the amount of annual leave that is being taken in
            advance and the day the leave will start.
          </p>
          <p>All fields are required unless marked optional.</p>
        </GreyBox>

        <Button className="ui is-primary button" onClick={props.handleStart}>
          Start
        </Button>

        <p>
          If you don&#39;t wish to use this tool, you can download and complete
          the following blank template letter.
        </p>
        <ul>
          <li>
            <DocumentLink
              name="Annual leave in advance template"
              urlDoc={Config.INTERACTIVE_TEMPLATE_AGREEMENT_ANNUAL_LEAVE_DOCX}
              urlPdf={Config.INTERACTIVE_TEMPLATE_AGREEMENT_ANNUAL_LEAVE_PDF}
              sizeDoc=" 51.9KB"
              sizePdf=" 62.6KB"
            />
          </li>
        </ul>
      </Accordion>
    </>
  )
}
